<ng-container *ngIf="original">
  <div class="lm-lpl-editor-toolbar toolbar editor-toolbar formatter-toolbar">
    <div class="buttonset">
      <button
          soho-menu-button
          class="btn-editor"
          (click)="onMonacoClickEvent('editor.action.quickCommand')"
      >{{ 'LPL_EDITOR_COMMANDS' | translate }}</button>
      <button
          soho-button="icon"
          icon="search"
          class="btn-editor"
          (click)="onMonacoClickEvent('actions.find')"
      ></button>
    </div>
  </div>

  <div class="editor-container lm-lpl-editor-diff" #editorContainer soho-alert></div>
</ng-container>

